import {
  faCheckCircle,
  faChevronRight,
  faPlus,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { BottomSheet } from "react-spring-bottom-sheet";
import Config from "../../config/Config";
import { default_menu_options } from "../../config/global";
import { setCustomApp } from "../../core/feature/company/customAppsSlice";
import { useAppDispatch, useAppSelector } from "../../core/feature/hooks";
import { setToken } from "../../core/feature/token/tokenSlice";
import {
  removeSwitchAccounts,
  setSwitchAccounts,
} from "../../core/feature/user/switchAccountSlice";
import { setUser } from "../../core/feature/user/userSlice";
import User from "../../core/models/user";
import { credentialCheck, getCustomApps } from "../../core/service/api";
import { Dialog, Transition } from "@headlessui/react";
import CustomApp from "../../core/models/customApp";
import { isDarkColor } from "../../config/DarkColorChecker";
import { toast } from "react-toastify";
export const SwitchAccount = ({ open, setOpen }: any) => {
  const switchAccounts: any[] = useAppSelector(
    (state) => state.switchAccounts.switchAccounts
  );
  const user: User = useAppSelector((state) => state.user.user);
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const language: String = useAppSelector((state) => state.language.language);
  const { t } = useTranslation();
  const onDismiss = () => {
    setOpen(false);
  };
  const env = Config.BaseUrlDev;
  let [item, setItem] = useState<any>({});
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const default_menu = { ...default_menu_options };
  let [isOpen, setIsOpen] = useState(false);

  const closeModal = () => {
    console.log("close modal");
    setIsOpen(false);
  };

  const SwipeListItem = ({ children, isActive = false, item }: any) => {
    const [offset, setOffset] = useState(0);
    const [startX, setStartX] = useState(0);
    const handleTouchStart = (e: any) => setStartX(e.touches[0].clientX);

    const handleTouchMove = (e: any) => {
      const deltaX = e.touches[0].clientX - startX;
      if (deltaX < 0) {
        setOffset(Math.max(deltaX, -100)); // limit swipe to -100px
      }
    };

    const handleTouchEnd = () => {
      setOffset(offset < -50 ? -100 : 0); // snap open or closed
    };

    const switchAccount = async () => {
      console.log(item.token);
      // return;
      try {
        const response = await credentialCheck(item.token);
        dispatch(setUser(response.data.user));
        dispatch(
          setToken(response.headers.authorization.replaceAll("Bearer ", ""))
        );
        dispatch(
          setSwitchAccounts({
            companyName: response.data.activeCompany.name,
            companyId: response.data.activeCompany.id,
            userId: response.data.user.id,
            name: response.data.user.name,
            photoUrl: response.data.user.photoUrl,
            lastService: item.lastService,
            token: response.headers.authorization.replaceAll("Bearer ", ""),
          })
        );
        if (item.lastService == "KATALIS") {
          var languageUpper = language.toUpperCase();
          console.log(response.data.activeCompany.customApps);
          if (response.data.activeCompany.customApps) {
            let resCustom = await getCustomApps(
              response.data.activeCompany.id,
              languageUpper
            );
            console.log(resCustom.data);
            dispatch(setCustomApp(resCustom.data));
            navigate("/home", { replace: true });
          } else {
            default_menu.app_menu.push({
              id: "63dfc62c31bd560297c12397",
              menu_name: "BSI",
              menu_path: "https://bsi-burekol.dev.teknologikartu.com/Home",
              menu_icon_url: "bsi",
              menu_is_show: true,
              menu_type: "URL",
            });
            dispatch(setCustomApp(default_menu));
            navigate("/home", { replace: true });
          }
        } else {
          console.log("kesinsi");
        }
      } catch (error: any) {
        console.log(error);
        if (
          error.response?.data?.status == 401 &&
          error.response?.data?.error === "Unauthorized" &&
          error.response?.data?.message === "Expired JWT token"
        )
          // toast.error(`removing account ${item.userId} because token expired`);
          dispatch(removeSwitchAccounts(item));
      } finally {
      }
    };

    if (isActive)
      return (
        <div className="flex gap-3 items-center p-2 border-b border-gray-200 transition-transform duration-200 bg-white">
          {children}
        </div>
      );
    return (
      <div className="relative overflow-hidden rounded-xl">
        {/* Hidden actions */}
        <div className="absolute right-0 top-0 h-full flex">
          <button
            className="!bg-red text-white px-10"
            onClick={() => {
              setIsOpen(true);
              onDismiss();
              setItem(item);
            }}
          >
            <FontAwesomeIcon icon={faTrashAlt} className="size-5" />
          </button>
        </div>
        {/* Swipe item */}
        <div
          className="flex gap-3 items-center p-2 border-b border-gray-200 transition-transform duration-200 bg-white"
          style={{ transform: `translateX(${offset}px)` }}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
          onClick={switchAccount}
        >
          {children}
        </div>
      </div>
    );
  };

  return (
    <>
      {/* ====================== CONFIRMATION POPUP ===================== */}
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    {t("PROFILE.removeAccount")}
                  </Dialog.Title>
                  <div>
                    <p className="text-sm text-gray-500 mt-2">
                      {t("PROFILE.removeAccountDesc")} {item.name}
                    </p>
                  </div>
                  <div className="justify-center mt-4 flex gap-2">
                    <button
                      type="button"
                      style={{
                        backgroundColor: customApp?.app_secondary_accent_color,
                      }}
                      className={`inline-flex justify-center rounded-md border border-transparent  px-4 py-2 text-sm font-medium ${
                        isDarkColor(customApp.app_secondary_accent_color)
                          ? "text-white"
                          : "text-black"
                      }`}
                      onClick={() => closeModal()}
                    >
                      {t("PROFILE.cancel")}
                    </button>
                    <button
                      type="button"
                      style={{
                        backgroundColor: customApp?.app_accent_color,
                      }}
                      className={`inline-flex justify-center rounded-md border border-transparent  px-4 py-2 text-sm font-medium ${
                        isDarkColor(customApp.app_accent_color)
                          ? "text-white"
                          : "text-black"
                      }`}
                      onClick={() => {
                        console.log("remove account");
                        closeModal();
                        try {
                          dispatch(removeSwitchAccounts(item));
                          toast.success(t("PROFILE.accountRemoved"));
                        } catch (error) {
                          toast.error(t("PROFILE.failedToRemoveAccount"));
                        }
                      }}
                    >
                      {t("PROFILE.remove")}
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
      {/* ================================================================ */}
      <BottomSheet
        defaultSnap={({ snapPoints, lastSnap }) =>
          lastSnap ?? Math.min(...snapPoints)
        }
        snapPoints={({ maxHeight }) => [
          maxHeight - maxHeight / 3,
          maxHeight * 0.8,
        ]}
        header={
          <h1 className="font-poppins flex items-left text-sm  font-bold text-black">
            {t("PROFILE.switchAccount")}
          </h1>
        }
        footer={
          <button
            onClick={onDismiss}
            className="w-full bg-psp-btn-primary shadow-lg shadow-psp-primary text-white py-2.5 text-sm font-semibold rounded-lg"
          >
            {t("ATTENDANCE-DETAIL.close")}
          </button>
        }
        // className="z-40"
        className="z-[999]"
        open={open}
        onDismiss={onDismiss}
      >
        <div className="p-3">
          {switchAccounts.map((item, index) => (
            <SwipeListItem
              isActive={user.id === item.userId}
              key={index}
              item={item}
            >
              <img
                src={`${env}main_a/image/get/${item.photoUrl}/pas`}
                alt={item.companyName}
                className="w-12 h-12 rounded-full object-cover"
              />
              <div className="flex flex-col grow">
                <span className="font-semibold">{item.name}</span>
                <span className="text-sm text-gray-500">
                  {item.companyName}
                </span>
              </div>
              <span>
                {user.id === item.userId ? (
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    className="text-psp-primary size-5"
                  />
                ) : (
                  <FontAwesomeIcon className="size-5" icon={faChevronRight} />
                )}
              </span>
            </SwipeListItem>
          ))}
          {switchAccounts.length < 5 && (
            <div
              className="flex gap-3 align-middle items-center p-2 border-b border-gray-200"
              onClick={() => {
                navigate("/login", {
                  state: { stopRedirect: true },
                });
              }}
            >
              <div className="size-12 rounded-full bg-psp-bg-secondary flex justify-center items-center">
                <FontAwesomeIcon
                  className="size-5"
                  icon={faPlus}
                ></FontAwesomeIcon>
              </div>
              <span className="font-semibold leading-[0]">
                {t("PROFILE.addNewAccount")}
              </span>
            </div>
          )}
        </div>
      </BottomSheet>
    </>
  );
};
